<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات حکم حقوقی"
        >
          <b-form
            @submit.prevent
          >
            <b-row>

              <b-col
                class="mt-2 form-size"
                md="8"
              >
                <b-row>
                  <b-col md="4">
                    <b-form-group
                      label="کاربر"
                      label-for="UserId"
                    >
                      <z-user v-model="Form.UserId" />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="تاریخ شروع"
                      label-for="StartDate"
                    >
                      <date-picker
                        v-model="Form.StartDate"
                        placeholder=""
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="تاریخ پایان"
                      label-for="EndDate"
                    >
                      <date-picker
                        v-model="Form.EndDate"
                        placeholder=""
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      label="توضیحات"
                      label-for="Description"
                    >
                      <b-form-textarea
                        id="Description"
                        v-model="Form.Description"
                        name="Description"
                        rows="3"
                        no-resize
                      />
                    </b-form-group>
                  </b-col>

                  <b-col
                    v-for="(item, index) in orderCategory"
                    :key="index"
                    cols="12"
                  >
                    <b-row>
                      <b-col cols="12">
                        <div class="divider divider-solid mb-2 mt-2">
                          <div
                            class="divider-text"
                            style="font-weight: 600;"
                          >{{ item.Title }}
                          </div>
                        </div>
                      </b-col>
                      <b-col
                        v-for="(ocp, index) in item.OrderCategoryProcess"
                        :key="index"
                        md="3"
                      >
                        <b-form-group
                          :label="ocp.Title"
                          :label-for="'OrderCategoryProcess' + index"
                        >
                          <b-input-group append="تومان">
                            <cleave
                              v-model="ocp.Price"
                              class="form-control"
                              :raw="false"
                              :options="options"
                            />
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import ZUser from '@/tools/user.vue'

export default {
  name: 'SalaryDetails',
  components: { ZUser },
  data() {
    return {
      Form: {
        Id: null,
        Description: null,
        SalaryOrderCategoryProcess: [],
        UserId: null,
        StartDate: null,
        EndDate: null,
      },
      loading: false,
      orderCategory: [],
      options: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalScale: 4,
      },
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    } else {
      this.getOrderCategory()
    }
  },
  methods: {
    save() {
      let url = this.$api.salary.add
      if (this.$route.params.id) {
        url = this.$api.salary.update
      }

      this.Form.SalaryOrderCategoryProcess = []

      this.orderCategory.forEach(item => {
        item.OrderCategoryProcess.forEach(process => {
          this.Form.SalaryOrderCategoryProcess.push({
            OrderCategoryProcessId: process.Id,
            Price: process.Price ? process.Price.replaceAll(',', '') : null,
          })
        })
      })

      this.loading = true
      this.$http.post(
        url, this.Form,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.salary.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
          this.getOrderCategory()
        })
    },
    getOrderCategory() {
      this.loading = true
      this.$http.post(
        this.$api.ordercategoryprocess.getall, null,
      )
        .then(res1 => {
          this.$http.post(
            this.$api.ordercategory.getall, null,
          )
            .then(res2 => {
              res2.data.forEach(item => {
                const OrderCategoryProcess = res1.data.filter(x => x.OrderCategory.Id == item.Id)

                OrderCategoryProcess.forEach(ocp => { ocp.Price = this.Form.SalaryOrderCategoryProcess.find(x => x.OrderCategoryProcessId == ocp.Id)?.Price })

                this.orderCategory.push({
                  Id: item.Id,
                  OrderCategoryProcess,
                  Title: item.Title,
                })
              })

              this.loading = false
            })
        })
    },
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}
</style>
